import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

export const defaultIcon = icon({ name: 'file', style: 'regular' });

export const routesExtraData = {
  'Data Loads': {
    icon: icon({ name: 'database', style: 'regular' }),
    reactRoute: '/data-loads',
    enabled: true,
  },
  Stripe: {
    reactRoute: '/stripe/payment-plans',
    icon: icon({ name: 'credit-card', style: 'regular' }),
  },
  Messages: {
    icon: icon({ name: 'envelope', style: 'regular' }),
    reactRoute: '/messages',
  },
  Appointments: {
    icon: icon({ name: 'book', style: 'regular' }),
    reactRoute: '/appointments',
  },
  'Time Card': {
    icon: icon({ name: 'book', style: 'regular' }),
    reactRoute: '/time-tracking',
  },
  Lifecycle: {
    icon: icon({ name: 'heartbeat', style: 'regular' }),
    reactRoute: '/lifecycle',
  },
  Products: {
    icon: icon({ name: 'box-taped', style: 'regular' }),
    reactRoute: '/products',
    children: [
      {
        id: 'products',
        reactRoute: '/products',
        name: 'Products',
        enabled: true,
      },
      {
        id: 'manage-inventory',
        reactRoute: '/products/inventory',
        name: 'Inventory',
        enabled: true,
      },
    ],
  },
  Reports: {
    icon: icon({ name: 'chart-area', style: 'regular' }),
    reactRoute: '/reports',
  },
  Dashboard: {
    icon: icon({ name: 'home', style: 'regular' }),
    reactRoute: '/dashboard',
  },
  Plans: {
    icon: icon({ name: 'clipboard-list', style: 'regular' }),
    reactRoute: '/workout-plans',
  },
  Exercises: {
    icon: icon({ name: 'dumbbell', style: 'regular' }),
    reactRoute: '/exercises',
  },
  Groups: {
    icon: icon({ name: 'users', style: 'regular' }),
    reactRoute: '/groups',
  },
  Clients: {
    icon: icon({ name: 'user', style: 'regular' }),
    reactRoute: '/clients',
  },
  Packages: {
    icon: icon({ name: 'box-taped', style: 'regular' }),
    route: '/fbm/packages',
  },
  Services: {
    icon: icon({ name: 'clipboard-list', style: 'regular' }),
    route: '/fbm/services',
  },
  Onboarding: {
    icon: icon({ name: 'user', style: 'regular' }),
    reactRoute: '/onboarding',
  },
  Emails: {
    icon: icon({ name: 'envelope', style: 'regular' }),
    reactRoute: '/emails',
  },
  'Platform Hierarchy': {
    icon: icon({ name: 'sitemap', style: 'regular' }),
    reactRoute: '/sites/hierarchy',
  },
  Sites: {
    icon: icon({ name: 'location-dot', style: 'regular' }),
    reactRoute: '/sites',
    enabled: true,
  },
  Schedule: {
    icon: icon({ name: 'calendar', style: 'regular' }),
    children: [
      {
        id: 'calendar',
        route: '/fbm/schedule',
        name: 'Calendar',
        enabled: true,
      },
      {
        id: 'visits',
        reactRoute: '/fbm/visits',
        name: 'Visits',
        enabled: true,
      },
      {
        id: 'members',
        reactRoute: '/fbm/scheduled-members',
        name: 'Recurring Members',
        enabled: true,
      },
      {
        id: 'services',
        reactRoute: '/fbm/services',
        name: 'Services',
        enabled: true,
      },
      {
        id: 'packages',
        reactRoute: '/fbm/packages',
        name: 'Packages',
        enabled: true,
      },
      {
        id: 'locations',
        reactRoute: '/fbm/locations',
        name: 'Locations',
        enabled: true,
      },
      {
        id: 'schedules',
        reactRoute: '/fbm/schedules',
        name: 'Availability Schedules',
        enabled: true,
      },
    ],
  },
  'Site Configuration': {
    icon: icon({ name: 'gear', style: 'regular' }),
    route: '/dashboard/trainer/custom',
    children: [
      {
        id: 'customize platform',
        route: '/dashboard/trainer/custom',
        name: 'Customize Platform',
        reactRoute: '/settings/platform',
        enabled: true,
      },
      {
        id: 'manage-roles',
        route: '/dashboard/roles-management',
        name: 'Staff Roles',
        reactRoute: '/site-configuration/roles',
        enabled: true,
      },
      {
        id: 'navigation',
        reactRoute: '/site-configuration/navigation',
        name: 'Navigation Menu Settings',
        enabled: true,
      },
      {
        id: 'habits',
        reactRoute: '/site-configuration/habits',
        name: 'Habits',
        enabled: true,
      },
      {
        id: 'tags',
        reactRoute: '/site-configuration/tags',
        name: 'Tags',
        enabled: true,
      },
      {
        id: 'lifecycle',
        reactRoute: '/lifecycle',
        name: 'Lifecycle',
        enabled: true,
      },
      {
        id: 'reports',
        reactRoute: '/site-configuration/reports',
        name: 'Reports',
        enabled: true,
      },
    ],
  },
  Account: {
    icon: icon({ name: 'user-gear', style: 'regular' }),
  },
  Booking: {
    icon: icon({ name: 'book', style: 'regular' }),
  },
  Automations: {
    icon: icon({ name: 'robot', style: 'regular' }),
  },
  Journal: {
    icon: icon({ name: 'book', style: 'regular' }),
  },
  Activity: {
    icon: icon({ name: 'running', style: 'regular' }),
  },
  Performance: {
    icon: icon({ name: 'chart-simple', style: 'regular' }),
    reactRoute: '/me/performance',
  },
  Snapshot: {
    icon: icon({ name: 'camera', style: 'regular' }),
    reactRoute: '/me/snapshots',
  },
  Measurements: {
    icon: icon({ name: 'weight-scale', style: 'regular' }),
    reactRoute: '/me/health',
  },
  Tags: {
    icon: icon({ name: 'tag', style: 'regular' }),
    reactRoute: '/tags',
  },
  Resources: {
    icon: icon({ name: 'weight', style: 'regular' }),
    reactRoute: '/site-configuration/resources',
  },
  Assessments: {
    icon: icon({ name: 'clipboard-check', style: 'regular' }),
  },
  'My Stuff': {
    icon: icon({ name: 'user', style: 'regular' }),
  },
  'My Measurements': {
    icon: icon({ name: 'weight-scale', style: 'regular' }),
    reactRoute: '/me/measurements',
  },
  Visits: {
    icon: icon({ name: 'calendar-check', style: 'regular' }),
    reactRoute: '/me/visits',
  },
  'My Assessments': {
    icon: icon({ name: 'clipboard-check', style: 'regular' }),
    reactRoute: '/me/assessments',
  },
  'My Videos': {
    icon: icon({ name: 'video', style: 'regular' }),
    reactRoute: '/me/videos',
  },
  Dependents: {
    icon: icon({ name: 'user-group', style: 'regular' }),
    reactRoute: '/me/dependents',
  },
  'My Progress Photos': {
    icon: icon({ name: 'camera-retro', style: 'regular' }),
    reactRoute: '/me/progress-photos',
  },
  'My Nutrition': {
    icon: icon({ name: 'utensils', style: 'regular' }),
    reactRoute: '/me/nutrition',
  },
  'My Resources': {
    icon: icon({ name: 'book-open', style: 'regular' }),
    reactRoute: '/me/resources',
  },
  'My Packages': {
    icon: icon({ name: 'box-taped', style: 'regular' }),
    reactRoute: '/me/packages',
  },
  'My Groups': {
    icon: icon({ name: 'users', style: 'regular' }),
    reactRoute: '/me/groups',
  },
  'My Rep Maxes': {
    icon: icon({ name: 'weight-scale', style: 'regular' }),
    reactRoute: '/me/rep-maxes',
  },
  'Point of Sale': {
    icon: icon({ name: 'credit-card', style: 'regular' }),
    reactRoute: '/pos-config/settings',
  },
  'Edit Profile': {
    icon: icon({ name: 'user-pen', style: 'regular' }),
    reactRoute: '/me/profile',
  },
  'Trainer Info': {
    icon: icon({ name: 'user-tie', style: 'regular' }),
    reactRoute: '/me/profile',
  },
  'My Workout Plans': {
    icon: icon({ name: 'box-taped', style: 'regular' }),
    reactRoute: '/me/workout-plans',
  },
  Trainers: {
    icon: icon({ name: 'users', style: 'regular' }),
    reactRoute: '/staff',
  },
  'Connected Apps': {
    icon: icon({ name: 'plug', style: 'regular' }),
    reactRoute: '/me/apps',
  },
  'My Connected Apps': {
    icon: icon({ name: 'plug', style: 'regular' }),
    reactRoute: '/me/apps',
  },
  'My Products': {
    icon: icon({ name: 'box-taped', style: 'regular' }),
    reactRoute: '/me/products',
  },
  Support: {
    icon: icon({ name: 'question', style: 'regular' }),
    reactRoute: '/support',
  },
  Links: {
    icon: icon({ name: 'link', style: 'regular' }),
    reactRoute: '/links',
  },
  Events: {
    icon: icon({ name: 'calendar-days', style: 'regular' }),
    reactRoute: '/events',
  },
  Videos: {
    icon: icon({ name: 'video', style: 'regular' }),
    reactRoute: '/videos',
  },
  'Measurement Reports': {
    icon: icon({ name: 'table', style: 'regular' }),
    reactRoute: '/health/reports',
  },
  'Customize Platform': {
    icon: icon({ name: 'gear', style: 'regular' }),
    reactRoute: '/settings/platform',
  },
};

export const clientRoutesExtraData = {
  Packages: {
    icon: icon({ name: 'box-taped', style: 'regular' }),
    externalLink: true,
    reactRoute: '/a/packages',
  },
  Exercises: {
    icon: icon({ name: 'dumbbell', style: 'regular' }),
    externalLink: true,
  },
  Groups: {
    icon: icon({ name: 'users', style: 'regular' }),
    externalLink: true,
  },
  Plans: {
    icon: icon({ name: 'clipboard-list', style: 'regular' }),
    externalLink: true,
  },
  Products: {
    icon: icon({ name: 'box-taped', style: 'regular' }),
    reactRoute: '/purchase/products',
    externalLink: false,
  },
  Booking: {
    icon: icon({ name: 'book', style: 'regular' }),
    externalLink: true,
    reactRoute: '/a/booking',
  },
};
